import React from 'react';
import c from 'classnames';

import { Link2Outline } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';

import { WebBookmarkLayout } from '../../types';
import { bookmarkStyles, containerBig, imageBig, imageSmall } from './style';
import { WebBookmarkCardProps } from './types';

const WebBookmarkCard: React.FC<WebBookmarkCardProps> = (props) => {
  const { url, title, desc, img, layout, coverImg } = props;

  const isSmallLayout = layout === WebBookmarkLayout.Small;
  const bigImg = coverImg;
  const smallImg = coverImg || img;

  return (
    <a
      className={c(
        bookmarkStyles,
        'webbookmark-container mb-16 flex overflow-hidden rounded-16 border border-border hover:shadow-02',
        isSmallLayout ? 'w-full' : c('flex-col', containerBig),
      )}
      href={url}
      rel="noreferrer noopener"
      target="_blank"
      title={url}>
      {(isSmallLayout && smallImg) || (!isSmallLayout && bigImg) ? (
        <div
          className={c(
            'h-full w-full border-divider',
            isSmallLayout ? c(imageSmall, 'border-e') : c(imageBig, 'border-b'),
          )}>
          <img
            alt={url}
            className="h-full w-full object-cover"
            src={isSmallLayout ? smallImg : bigImg}
          />
        </div>
      ) : null}
      <div className="overflow-hidden p-20 pe-40">
        {title ? (
          <Typography
            className="max-w-576 break-all text-text-primary"
            numberOfLines={1}
            variant="heading-xs">
            {title}
          </Typography>
        ) : null}
        {desc ? (
          <Typography
            className="mt-12 text-text-secondary"
            numberOfLines={2}
            variant="body-short-02">
            {desc}
          </Typography>
        ) : null}
        {url ? (
          <div className="mt-16 flex">
            <div className="flex items-center">
              <Link2Outline fillColorToken="icon-secondary" height={16} width={16} />
            </div>
            <Typography
              className="max-w-512 break-all text-text-primary ms-4"
              numberOfLines={1}
              variant="body-short-02">
              {url}
            </Typography>
          </div>
        ) : null}
      </div>
    </a>
  );
};

export default WebBookmarkCard;
